<template>
  <div class="Hits">
    <div class="dash-all">
      <div class="all-item">
        <div class="logo">
          <svg
            t="1646919070954"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="4113"
            width="100"
            height="100"
          >
            <path
              d="M467.6 259.14c-64.3 0-116.85 48.57-116.85 109.06v2.17l0.65 2.08c4.88 15.52 17.78 23.45 31.75 20.73 12.16-2.36 22.43-12.54 22.43-25 0-30.8 27.53-56.24 62-56.24s62 25.43 62 56.24c0 10.42 9.42 19.21 19.93 22.15 12.72 3.54 25.48-1.79 33.06-15.17l1.84-3.25v-3.71c0.04-60.49-52.51-109.06-116.81-109.06z m3 137.42c-18.44 0-33.23 15.22-33.23 33.78v174.05L405 571.05l-2-2-0.6-0.56c-13.4-11.87-35.4-10.79-47.97 2.24-13.52 14-15 35-0.66 49.89l106.46 109.57c23.33 24 53.69 34.63 99.37 34.63 49.61 0 81.28-12.09 98.94-37.34 14-20 17.69-42.75 18-84.82v-92c0-12.75-5.18-22.59-14.08-28.4a33.3 33.3 0 0 0-17.46-5.42h-1A31.92 31.92 0 0 0 618.72 529c-0.47-12.73-7-22.19-16.85-27.6a37.49 37.49 0 0 0-15.41-4.62H583.89a31.78 31.78 0 0 0-23.39 12.3v-0.36c0-14.08-6.52-24.41-17-29.83a34.2 34.2 0 0 0-15.91-3.89h-0.1l-1.46 0.05a32 32 0 0 0-23.52 12.37v-57.07c0-18.57-13.37-33.79-31.9-33.79zM512 62c248.53 0 450 201.47 450 450S760.53 962 512 962 62 760.52 62 512 263.48 62 512 62z"
              fill="#5932ea"
              p-id="4114"
            />
          </svg>
        </div>
        <div class="content">
          <div class="title">总使用次数</div>
          <div class="value">
            <span class="r-value">{{ all }}</span
            >次
          </div>
        </div>
      </div>
      <div class="all-item">
        <div class="logo">
          <svg
            t="1646919119926"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="5633"
            width="100"
            height="100"
          >
            <path
              d="M534.1 207.332c39.1-39.1 90.3-58.6 141.5-58.6 39.2 0 78.4 11.4 112.1 34.3l76.1-76.1c1.6-1.5 3.6-2.3 5.7-2.3s4.1 0.7 5.7 2.3l42.4 42.4c3.1 3.1 3.1 8.2 0 11.4l-76.1 76.1c52.7 77.8 44.6 184.5-24.3 253.5l-101.9 101.9c-1.6 1.5-3.7 2.3-5.7 2.3-2.1 0-4.1-0.7-5.7-2.3l-271.7-271.7c-3.1-3.1-3.1-8.2 0-11.3z m-225.6 225.5c1.6-1.5 3.7-2.3 5.7-2.3 1.156 0 2.282 0.212 3.327 0.67l-0.031 0.034 276.02 276.02c1.065 2.848 0.46 6.2-1.816 8.476l-101.9 101.9c-39.1 39.1-90.3 58.6-141.5 58.6-39.2 0-78.4-11.4-112.1-34.3l-76.1 76.1c-1.6 1.5-3.6 2.3-5.7 2.3s-4.1-0.7-5.7-2.3l-42.4-42.4c-3.1-3.1-3.1-8.2 0-11.3l76.1-76.1c-52.7-77.8-44.6-184.5 24.3-253.5z m273.7-177.4l-59.4 59.4 186.8 186.8 59.4-59.4c24.9-25 38.7-58.1 38.7-93.4 0-35.3-13.8-68.5-38.7-93.4-25-25-58.1-38.7-93.4-38.7-35.3 0-68.5 13.8-93.4 38.7z m-268 268l-59.4 59.4c-25 25-38.7 58.1-38.7 93.4 0 35.3 13.8 68.5 38.7 93.4 25 25 58.1 38.7 93.4 38.7 35.3 0 68.5-13.8 93.4-38.7l59.4-59.4-186.8-186.8z"
              fill="#5932ea"
              p-id="5634"
            />
            <path
              d="M567.811 548.615a8 8 0 0 1 11.314 0l33.941 33.941a8 8 0 0 1 0 11.314l-66.468 66.468-45.255-45.255 66.468-66.468zM429.22 410.022a8 8 0 0 1 11.313 0l33.941 33.942a8 8 0 0 1 0 11.313l-66.468 66.468-45.255-45.255 66.469-66.468z"
              fill="#44D7B6"
              p-id="5635"
            />
          </svg>
        </div>
        <div class="content">
          <div class="title">API调用</div>
          <div class="value">
            <span class="r-value">{{ api }}</span> 次
          </div>
        </div>
      </div>
      <div class="all-item">
        <div class="logo">
          <svg
            t="1646920156735"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="6651"
            width="100"
            height="100"
          >
            <path
              d="M928.5 359L781.6 138.7C763.8 112 733.9 96 701.7 96H322.3c-32.2 0-62 16-79.9 42.7L95.5 359c-11.5 17.2-17 37.2-16 57.8 1 20.6 8.4 40 21.4 56L437.5 887c18.3 22.5 45.5 35.5 74.5 35.5s56.2-12.9 74.5-35.5l336.6-414.3c13-16 20.4-35.4 21.4-56 0.9-20.5-4.6-40.5-16-57.7z m-55.1 73.4L536.8 846.7c-6.1 7.5-15.2 11.8-24.8 11.8s-18.7-4.3-24.8-11.8L150.6 432.4c-8.9-10.9-9.6-26.2-1.8-37.9l146.8-220.3c5.9-8.9 15.9-14.2 26.6-14.2h379.5c10.7 0 20.7 5.3 26.6 14.2l146.8 220.3c7.9 11.7 7.2 27-1.7 37.9z"
              fill="#5932ea"
              p-id="6652"
            />
            <path
              d="M660 455c-13.8-11-33.9-8.8-45 5L512 588.8 409 460c-11-13.8-31.2-16-45-5s-16 31.2-5 45l128 160c6.1 7.6 15.3 12 25 12s18.9-4.4 25-12l128-160c11-13.8 8.8-33.9-5-45z"
              fill="#feaed7"
              p-id="6653"
            />
          </svg>
        </div>
        <div class="content">
          <div class="title">会员状态</div>
          <div class="value">
            <span class="r-value">正常</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getClicks } from "@/api/user";
export default {
  name: "Hits",
  data() {
    return {
      all: 0,
      api: 0,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      getClicks().then((res) => {
        this.api = res.data.api;
        this.all = res.data.total;
      });
    },
  },
};
</script>
<style lang="less" scoped>
.dash-all {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 1rem 2rem;
  border-radius: 10px;
  .all-item {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    .content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .title {
        margin: 0;
        opacity: 0.8;
      }
      .value {
        flex: 1;
        .r-value {
          font-size: 2.6rem;
        }
      }
    }
  }
}
</style>
